<template>
  <div>
    <table class="table table-hover">
      <tbody>
        <tr v-for="story in stories" :key="story.id" class="pointer">
          <td @click="toStory(story.id)">
            <el-image
              style="width: 70px; height: 70px"
              :src="story.thumb_story_list_url"
              fit="contain"
            ></el-image>
          </td>
          <td @click="toStory(story.id)">
            <h5 class="m-b-10" :class="{'text-muted': !story.title}">
              <span v-if="story.rich_title" v-html="story.rich_title"></span>
              <span v-else>{{ story.title || 'Aucun titre' }}</span>
              <br />
              <small>
                <i v-if="story.scheme == 'VIDEO'" class="fa fa-television"></i>
                <i v-if="story.scheme == 'STORY'" class="fa fa-file-text-o"></i>
                <span
                  :class="{'badge-success': story.status == 'PUBLISHED', 'badge-danger': story.status == 'DISABLED'}"
                  class="badge m-l-5 m-r-5"
                >{{ story.status | translate }}</span>
                <span v-if="story.authors.length > 0">
                  par
                  <span v-for="author in story.authors" :key="author.id">{{ author.screenname }}</span>
                </span>
                - créé {{ story.created_at | fromNowDate }}
                - publié le {{ story.published_at | formatDate('DD/MM/YYYY à HH:mm') }}
                <span
                  v-if="story.primary_category && story.primary_category.label"
                >
                  -
                  <span>
                    <i class="fa fa-folder-o"></i>
                    {{ story.primary_category.label }}
                  </span>
                </span>
              </small>
            </h5>
          </td>
          <td v-if="edit === true" @click="toStory(story.id, true)" class="text-right m-t-20">
            <button class="btn btn-outline d-sm-none d-md-inline">
              <i class="fa fa-pencil"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <hr class="m-t-10" />
    <div class="text-center">
      <el-pagination
        @size-change="setPage"
        @current-change="setPage"
        :page-size="pagination.per_page"
        :pager-count="5"
        :page-count="pagination.pages"
        :page-sizes="[8, 16, 24, 50, 100]"
        :current-page="pagination.page"
        layout="total, prev, pager, next"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: "stories",
  props: {
    stories: Array,
    pagination: Object,
    edit: Boolean,
    toStory: { type: Function },
    setPage: { type: Function }
  },
  methods: {}
};
</script>
<style>
</style>
